import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

export abstract class AbstractApiDataService {

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * The throwError could be catch by the global error handler, if not handled in the caller.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  protected handleError<TError>(operation = 'operation', result?: TError) {
    return (error: any): Observable<TError> => {

      // TODO: send the error to remote logging infrastructure
      console.error('BaseDataService handleError...:', error); // log to console instead

      // rewrite unknown error message for site disabled
      if (error.statusText === 'Unknown Error' && error.message === 'Http failure response for (unknown url): 0 Unknown Error') {
        return throwError(new HttpErrorResponse({ error, status: 500, statusText: 'The api server is disabled' }));
      }
      return throwError(error);
    };
  }
}
